import * as React from "react";
import { connect } from "react-redux";
import { utils as XLSXUtils, write as XLSXWrite } from 'xlsx';
import { Container, Dropdown, Accordion, Card, Button ,Form,Spinner,} from "react-bootstrap";
import { format,isToday, subDays, addDays, getDay, parseISO, isBefore } from 'date-fns';
import { FiChevronDown } from "react-icons/fi";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../Common/Services/CustomerService";
import  CustomerMasterSlidout  from "./Masters/CustomerMasterSlidout";
import { SingleDropdownListWithoutSearch } from "../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, { Search ,CSVExport}  from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { VendorService } from "../Common/Services/VendorService";
import DatePicker from "react-datepicker";
import  LaborSlideout  from "./LaborSlideout";
const { SearchBar } = Search;
import paginationFactory from 'react-bootstrap-table2-paginator';

import _ from "lodash";
 
import createDOMPurify from "dompurify";
import { Utils } from "../Common/Utilis";
import moment from "moment";
import { UserService } from "../Common/Services/UserService";
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime =
  storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
const formattedDate = Utils.convertUtcToTimezoneFormat(
  new Date(),
  currentUtcTime
);
let tenantName = storage === null ? '' : `${storage.firstName} ${storage.lastName}`;
  
 class LaborTimesheets extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
          disableExport:true,
          exportedDate:null,
          totalhrs:0,
          totaldot:0,
          totalot:0,
          totalreg:0,
          isSpinner:false,
          downloadData:[],
          selectedEmpIds:[],
          payrollDetails:[],
          isSaveOpen: false,
          loading: false,
          isWait: false,
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          biWeekly:true,
          searcResult: [
            {
                name:"John smith",
                employeecode:"E1001",
                status:"Salaried",
                TotalHrs:"40",
                Regular:"40",
                OT:"2",
                PTO:"0"
            },
            {
                name:"Lee win",
                employeecode:"E1001",
                status:"Salaried",
                TotalHrs:"40",
                Regular:"40",
                OT:"2",
                PTO:"0"
            }
          ],
          customerid:0,
          selectedcolumn: "All",
          selectOptions: [
            { id: 'All', name: 'All'},
            { id: 'Emp. Code', name: 'Emp. Code' },
            { id: 'Emp. Name', name: 'Emp. Name' },
          ],
          startDate:new Date(formattedDate),
          endDate: new Date(formattedDate),
          periodStartDate:new Date(formattedDate),
          periodEndDate:new Date(formattedDate),
          exportColumns:[{dataField: 'empCode', text: 'Emp Code'}],
          cimmpleColumns:[
          { dataField: 'empCode', text: 'Emp Code' },
          { dataField: 'ssn', text: 'SSN' },
          { dataField: 'wG2Code', text: 'WG2 Code' },
          { dataField: 'payPeriodStart1', text: 'Pay Period Start' },
          { dataField: 'payPeriodEnd1', text: 'Pay Period End' },
          { dataField: 'payDesignation', text: 'Pay Designation' },
          { dataField: 'hours', text: 'Hours' },
          ],
         adpColumns : [
          { dataField: 'coCode', text: 'Co Code' },
          { dataField: 'batchId', text: 'Batch ID' },
          { dataField: 'filenames', text: 'File#' },
          { dataField: 'payDesignation', text: 'Pay#' },
          { dataField: 'regular', text: 'Regular Hours' },
          { dataField: 'ot', text: 'OT' },

          { dataField: 'earning1Code', text: 'Earning 1 Code' },
          { dataField: 'earning1Value', text: 'Earning 1 Amount' },
          { dataField: 'earning2Code', text: 'Earning 2 Code' },
          { dataField: 'earning2Value', text: 'Earning 2 Amount' },
          { dataField: 'earning3Code', text: 'Earning 3 Code' },
          { dataField: 'earning3Value', text: 'Earning 3 Amount' },
          { dataField: 'earning4Code', text: 'Earning 4 Code' },
          { dataField: 'earning4Value', text: 'Earning 4 Amount' },
          { dataField: 'earning5Code', text: 'Earning 5 Code' },
          { dataField: 'earning5Value', text: 'Earning 5 Amount' },
          { dataField: 'earning6Code', text: 'Earning 6 Code' },
          { dataField: 'earning6Value', text: 'Earning 6 Amount' },
          { dataField: 'earning7Code', text: 'Earning 7 Code' },
          { dataField: 'earning7Value', text: 'Earning 7 Amount' },
          { dataField: 'earning8Code', text: 'Earning 8 Code' },
          { dataField: 'earning8Value', text: 'Earning 8 Amount' },
          { dataField: 'earning9Code', text: 'Earning 9 Code' },
          { dataField: 'earning9Value', text: 'Earning 9 Amount' },
          { dataField: 'earning10Code', text: 'Earning 10 Code' },
          { dataField: 'earning10Value', text: 'Earning 10 Amount' },
          { dataField: 'earning11Code', text: 'Earning 11 Code' },
          { dataField: 'earning11Value', text: 'Earning 11 Amount' },
          { dataField: 'earning12Code', text: 'Earning 12 Code' },
          { dataField: 'earning12Value', text: 'Earning 12 Amount' },
          { dataField: 'earning13Code', text: 'Earning 13 Code' },
          { dataField: 'earning13Value', text: 'Earning 13 Amount' }
         ]


        };
        
     
      }
      
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.GetPayrollDetails(requestlist);
      }

        componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId) {
          this.GetPayrollDetails({});
          // this.getExportDate();
          // this.GetUserTimesheets({});
        }
      }

          getExportDate = () => {
              const requestlist:any = {};
              requestlist.startDate = this.state.periodStartDate;
              requestlist.endDate = this.state.periodEndDate;
              UserService.GetExportData(requestlist)
                .then(async (result: any | null) => {
                  if (result != null) {
                   
                    this.setState({ exportedDate: result.exportedDate });
                  }else{
                  this.setState({ exportedDate: null });

                  }
                  resolve();
                })
                .catch((err: any) => {
                  toast.error(`Server Error, ${err}`);
                  reject();
                });
                };

              DeExportData = () => {
              this.setState({isSpinner:true});
              const requestlist:any = {};
              requestlist.startDate = this.state.periodStartDate;
              requestlist.endDate = this.state.periodEndDate;
              UserService.DeExportData(requestlist)
                .then(async (result: any | null) => {
                  this.setState({  isSpinner:false },()=>{
                     this.getExportDate();
                     this.GetUserTimesheets({});
                    });
                  resolve();
                })
                .catch((err: any) => {
                  toast.error(`Server Error, ${err}`);
                  this.setState({isSpinner:false});
                  reject();
                });
                };

    

      GetUserTimesheets = (requestlist: any) => {
        requestlist.startDate = this.state.periodStartDate;
        requestlist.endDate = this.state.periodEndDate;
          UserService.GetUserTimesheets(requestlist)
            .then(async (result: any | null) => {
              if (result != null) {
               const totalhrs = result.reduce((sum: number, row: any) => sum + (parseFloat(row.totalHrs) || 0), 0).toFixed(2);
               const totalot = result.reduce((sum: number, row: any) => sum + (parseFloat(row.ot) || 0), 0).toFixed(2);
               const totaldot = result.reduce((sum: number, row: any) => sum + (parseFloat(row.dot) || 0), 0).toFixed(2);
               const reg1 = result.reduce((sum: number, row: any) => sum + (parseFloat(row.regular1) || 0), 0);
               const reg2 = result.reduce((sum: number, row: any) => sum + (parseFloat(row.regular2) || 0), 0);
               this.setState({ searcResult: [],totalhrs,totalot,totaldot,totalreg:(reg1+reg2).toFixed(2), selectedEmpIds: result.filter(row => row.payroll_id).map(row => row.empid) },()=>{
                 this.setState({searcResult:result});
               });
              }
              resolve();
            })
            .catch((err: any) => {
              toast.error(`Server Error, ${err}`);
              reject();
            });
            };

            GetPayrollDetails = (requestlist: any) => {
          
              UserService.GetPayrollDetails(requestlist)
                .then(async (result: any | null) => {
                  if (result != null) {
                   
                    this.setState({ payrollDetails: result, biWeekly: result.payperiod == 2 },()=>{
                      this.getPayrollDateRange();
                    });
                  }
                  resolve();
                })
                .catch((err: any) => {
                  toast.error(`Server Err, ${err}`);
                  reject();
                });
                };

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let chkisstatus = id == "Status" ? true : false;
        let chkisPhoneNumber = id == "Phone Number" ? true : false;
        let chkisaddress = id == "Address" ? true : false;
        let chkiscustomername = id == "Customer Name" ? true : false;
        let chkiscustomercode = id == "Customer Code" ? true : false;
    
    
        if (id == "All") {
          chkisstatus = true;
          chkisPhoneNumber = true;
          chkisaddress = true;
          chkiscustomername = true;
          chkiscustomercode = true;
    
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isstatus: chkisstatus, isphone_number: chkisPhoneNumber, isaddress: chkisaddress,
          iscompanyname: chkiscustomername, iscustomercode: chkiscustomercode
        },
          () => {
            this.setState({ searcResult: searcResult1 });    
          }
    
    
        );
    
      };
 
exportCSV = (triggerExport) => {
  this.setState({isSpinner:true});
  console.log("selectedEmpIds----------",this.state.selectedEmpIds);
  let requestlist:any = {};
  requestlist.startDate = this.state.periodStartDate;
  requestlist.endDate = this.state.periodEndDate;
  requestlist.empids = this.state.selectedEmpIds;
  requestlist.exportedDate = new Date(formattedDate);

  if(this.state.selectedEmpIds.length <= 0){
   toast.error("No data to export.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({isSpinner:false});
      return;
  };

  UserService.GetCimmpleFormat(requestlist)
      .then((result: any | null) => {
        if (result !== null) {
           const columnSet = Object.keys(result[0]).length > 30 ? this.state.adpColumns : this.state.cimmpleColumns;
           this.setState({ downloadData: result,exportColumns: columnSet,isSpinner:false }, () => {
           triggerExport();
          toast.success("Payroll has been exported and Please find the downloaded excel sheet for the details.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.getExportDate();
          this.GetUserTimesheets({});
          const csvString = this.convertToCSV(result);
          this.sendCSVEmail(csvString);

        });
        }
      })
      .catch((error: any) => {
        toast.error("Failed to download", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        this.setState({ isSpinner: false });
      });

};



convertToCSV = (data) => {
  if (!data || data.length === 0) return '';

  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','),
    ...data.map(row => headers.map(h => `"${(row[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')),
  ];

  return csvRows.join('\n');
};

sendCSVEmail = async (csvString) => {
  const fileName = 'Time_clock.csv';
  const blob = new Blob([csvString], { type: 'text/csv' });
  const file = new File([blob], fileName, { type: 'text/csv' });

  const formData = new FormData();
  formData.append('MailTo', this.state.payrollDetails.email);
  formData.append('MailCC', '');
  formData.append('Subject', 'Exported Payroll Attachment');
  formData.append('MailBody', `Dear ${tenantName},\nPlease find the exported time clock file attached.`);
  formData.append('IsBodyHtml', 'true');
  formData.append('Files', file); 

  try {
    await VendorService.SendMail(formData);
  } catch (error) {
    console.error('Error sending email:', error);
  }
};


  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({ showLaborSlideout:true, laborData: row});  
    },
  };
  
  showNewSlideOut = () => {
    this.setState({ showSlideout: true ,customerid:0,isSpinner:false});  
  };

  closeSlideOut = () => {
    this.setState({ showLaborSlideout: false, isSpinner:false, });
    this.GetUserTimesheets({});
};


 
  changeStartDate = (date) => {
    this.setState({ startDate: date }, () => {
        this.getPayrollDateRange(); 
    });
};


discard = () => {
    this.setState({ isSaveOpen: false }, () => {
       
    });
  };

updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let isSaveOpen =true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let searcResult = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.searcResult))
      );

    
      if (type === "Regular") {
        
        e.preventDefault();
      
        searcResult[index].Regular = e.target.value;

        this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
          $("input[id^='txtregular" + txtID + "txt']").focus();
          
        let txtdesc =  $("input[id^='txtregular" + txtID + "txt']")[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
        });
      }
      
      if (type === "OT") {
        e.preventDefault();

        searcResult[index].OT = e.target.value;

        this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
          $("input[id^='txtot" + txtID + "txt']").focus();
          let txtdesc =  $("input[id^='txtot" + txtID + "txt']")[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
        });
      }
      
      if (type === "PTO") {
        e.preventDefault();
        searcResult[index].PTO = e.target.value;

        this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
          $("input[id^='txtpto" + txtID + "txt']").focus();
          let txtdesc =  $("input[id^='txtpto" + txtID + "txt']")[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
        });
      
      }
   
    }
  };
  
getPayrollDateRange = () => {
    const { startDate, payrollDetails } = this.state;

    if (!startDate || !payrollDetails) return;

    const payDetails = payrollDetails;
    const payPeriod = payDetails.payperiod; 
    const daysInPeriod = payPeriod === 1 ? 7 : 14;

    const payrollStartRaw = new Date(payDetails.payrollstartdate);
    const payrollStartDate = new Date(Date.UTC(
        payrollStartRaw.getFullYear(),
        payrollStartRaw.getMonth(),
        payrollStartRaw.getDate()
    ));

    const payWeekDay = payDetails.payweekdate; 

    const selected = new Date(startDate);
    const selectedUTC = new Date(Date.UTC(
        selected.getFullYear(),
        selected.getMonth(),
        selected.getDate()
    ));

    const startDay = payrollStartDate.getUTCDay();
    const daysToAdd = (payWeekDay - startDay + 7) % 7;

    const alignedStart = new Date(payrollStartDate);
    alignedStart.setUTCDate(payrollStartDate.getUTCDate() + daysToAdd);

    const diffTime = selectedUTC.getTime() - alignedStart.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    const periodIndex = diffDays < 0 ? 0 : Math.floor(diffDays / daysInPeriod);

    const now = new Date(formattedDate);

    const periodStartDate = new Date(alignedStart);
    periodStartDate.setUTCDate(alignedStart.getUTCDate() + periodIndex * daysInPeriod);
    periodStartDate.setUTCHours(now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());

    const periodEndDate = new Date(periodStartDate);
    periodEndDate.setUTCDate(periodStartDate.getUTCDate() + daysInPeriod - 1);
    periodEndDate.setUTCHours(now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());

    const formattedStart = periodStartDate.toISOString();
    const formattedEnd = periodEndDate.toISOString();

    now.setHours(0, 0, 0, 0);
    const disableExport = periodEndDate > now;

    this.setState({
        periodStartDate: formattedStart,
        periodEndDate: formattedEnd,
        disableExport
    }, () => {
        this.getExportDate();
        this.GetUserTimesheets({});
    });
};



  getPayrollDateRange1 = () => {
    const { startDate, payrollDetails } = this.state;

    if (!startDate || !payrollDetails || payrollDetails.length === 0) return null;

    const payDetails = payrollDetails;
    const payperiod = payDetails.payperiod;
    const payweekdate = payDetails.payweekdate; 

    const jsDayIndex = payweekdate % 7; 
    const selectedDay = startDate.getDay(); 
    let diff = selectedDay - jsDayIndex;
    if (diff < 0) diff += 7; 

    const periodStartDate = subDays(startDate, diff);
    console.log("selectedDay",selectedDay);
    console.log("jsDayIndex",jsDayIndex);

    const intervalDays = payperiod === 2 ? 13 : 6;
    const periodEndDate = addDays(periodStartDate, intervalDays);

    const startDateIso = new Date(periodStartDate).toISOString();
    const endDateIso = new Date(periodEndDate).toISOString();
    const today = new Date(formattedDate);
    today.setHours(0, 0, 0, 0); 
    const disableExport = periodEndDate > today;

    console.log("periodStartDate",startDateIso,endDateIso,disableExport);

    this.setState({
        periodStartDate: startDateIso,
        periodEndDate: endDateIso,
        disableExport
    },()=>{
      this.getExportDate();
      this.GetUserTimesheets({});
    });


    // return {
    //     start: format(periodStartDate, 'dd MMM yyyy'),
    //     end: format(periodEndDate, 'dd MMM yyyy')
    // };
};

moreActions = (eventKey: any) => {
    if (eventKey == "deexport") {
     this.DeExportData();
    }
   
  };

  render() {
    console.log("payrollDetails--",this.state.payrollDetails);
    const { periodStartDate, periodEndDate } = this.state;
    const { ExportCSVButton } = CSVExport;
  
  const CustomDateInput = React.forwardRef<HTMLButtonElement, { value?: string; onClick?: () => void; placeholder?: string }>(
      ({ value, onClick, placeholder }, ref) => (
        <button
          type="button"
          className="custom-datepicker-btn"
          onClick={onClick}
          ref={ref}
        >
          {value || placeholder}
           <div className="drop-arrow ml-0 d-flex">
                <FiChevronDown />
              </div>
        </button>
      )
    );
    
    const formattedStart = periodStartDate ? format(new Date(periodStartDate), 'dd MMM yyyy') : null;
    const formattedEnd = periodEndDate ? format(new Date(periodEndDate), 'dd MMM yyyy') : null;
    
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.searcResult.length
      }] // A numeric array is also available. the purpose of above example is custom the text
    };
    const {
      
      showSlideout,
      
  } = this.state;

  const columns = [   
    {
        searchable: this.state.iscompanyname,
        headerStyle: { width: '15%' },
        dataField: 'firstName',
        text: 'Name',
        sort: true,
    },
    {
      searchable: this.state.iscustomercode,
      headerStyle: { width: '15%' },
      dataField: 'empCode',
      text: 'Emp. Code',
      sort: true,
    },
    {
      searchable: this.state.isaddress,
      headerStyle: { width: '15%' },
      dataField: 'employeeType',
      text: 'Emp. Status',
    },   
    {
        searchable: this.state.isphone_number,
        headerStyle: { width: '10%' },
        dataField: 'totalHrs',
        text: 'Total Hrs.',
      formatter: (cell, row) => {
        if (row.totalHrs) {
          const x = row.totalHrs || 0;
          return x.toFixed(2);
        } else {
          return "-";
        }
  }
    },
    {
      dataField: 'regularSum',
      headerStyle: { width: '10%' },
      text: 'Regular',
      formatter: (cell, row) => {
        if (row.regular1) {
        const reg1 = parseFloat(row.regular1) || 0;
            const reg2 = parseFloat(row.regular2) || 0;
            const total = reg1 + reg2;
            return  total.toFixed(2);
        } else {
          return "-";
        }
      }
    },
    {
        dataField: 'ot',
        headerStyle: { width: '10%' },
        text: 'OT',
        formatter: (cell, row) => {
          if (row.payroll_id) {
            const x = (row.ot || 0);
              return  x.toFixed(2);
          } else {
            return "-";
          }
        }
    },
     {
      dataField: 'dot',
      headerStyle: { width: '10%' },
      text: 'DOT',
      formatter: (cell, row) => {
          if (row.payroll_id) {
            const x = (row.dot || 0);
              return  x.toFixed(2);
          } else {
            return "-";
          }
        }
    },
    
    {
        dataField: 'holiday',
        headerStyle: { width: '10%' },
        text: 'Holiday',
       formatter: (cell, row) => {
          if (row.payroll_id) {
            const x = (row.holiday || 0);
              return  x.toFixed(2);
          } else {
            return "-";
          }
        }
    },
    {
        dataField: 'pto',
        headerStyle: { width: '10%' },
        text: 'PTO',
       formatter: (cell, row) => {
          if (row.payroll_id) {
            const reg1 = parseFloat(row.sick) || 0;
              const reg2 = parseFloat(row.vacation) || 0;
              const total = reg1 + reg2;
              return  total.toFixed(2);
          } else {
            return "-";
          }
        }
    },

  ];
    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

             Timesheets
              {/* <div className="action-group d-flex flex-row ml-auto">
                <Button onClick={this.showNewSlideOut}>Add New</Button>
              </div> */}
            </div>

            <section className="mt-3">
            

            <ToolkitProvider
        keyField="id"
        data={this.state.searcResult}
        columns={columns}
        exportCSV={{fileName: `Exported Payroll - ${new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '')}.csv` }}
        
        search
      >
        {
          props => (


            <div >
              <section className="d-flex flex-wrap gap-3 pb-2 align-items-center">
                <div className="position-relative mb-2">
                  <SearchBar {...props.searchProps} />
                </div>

                {/* <div className="d-flex align-items-center"> */}
                  <div className="col-12 col-md-2 mb-2">
                    <SingleDropdownListWithoutSearch
                      
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}

                    />
                    {/* </div> */}
                </div>

                       
                            {/* <div className="ms-auto">
                               Payroll Pay Period : <strong>{formattedStart}</strong> to <strong>{formattedEnd}</strong>
                            </div> */}
                           <div className="action-group d-flex flex-row ml-auto mb-2"> 
              <ToolkitProvider
  keyField="id"
  data={this.state.downloadData} 
  columns={this.state.exportColumns}
  // exportCSV={{ fileName: 'Time_clock.csv' }}
  exportCSV={{fileName: `Exported Payroll - ${new Date(formattedDate).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '')}.csv` }}

>
  {props => (
    <>
        {this.state.exportedDate && 
        <span className="badge badge-pill badge-primary color-green mt-2">Exported Date: {moment(this.state.exportedDate).format("MM/DD/YYYY")}</span>
        }

      {!this.state.exportedDate &&  !this.state.disableExport &&
      <button
        className="btn btn-primary"
        onClick={() => this.exportCSV(props.csvProps.onExport)}
      >
        Export Payroll
      </button>
      }

      {this.state.exportedDate &&
      <div className="action">



                            <Dropdown
                              className="more-action"
                              
                              onSelect={(event: any) => { this.moreActions(event); }}
                            >
                              <Dropdown.Toggle
                                className="btn-outline-primary btn btn-primary more"
                                id="dropdown-more"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                </svg>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                  
                                   <Dropdown.Item
                                      eventKey={"deexport"}
                                      key={1}
                                    >
                                      {"Un-Export"}
                                    </Dropdown.Item>

                              </Dropdown.Menu>
                            </Dropdown>



       </div>}

      <div style={{ display: 'none' }}>
        <BootstrapTable {...props.baseProps} />
      </div>
    </>
  )}
              </ToolkitProvider>
                </div>   
             
                
              </section>
             <section className="mb-3">
               <div className="col-12 col-md-6">
                   <div className="card h-100 w-75 shadow-sm">
                     <div className="card-header fw-bold">
                        <div className="d-flex justify-content-between align-items-center">
                                <Form.Group controlId="date">
                                    <div className="d-flex align-items-center">
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={this.changeStartDate}
                                        selectsStart
                                        className="form-control form-control-md text-center w-75"
                                        startDate={this.state.startDate}
                                        endDate={this.state.endDate}
                                        maxDate={new Date(formattedDate)}
                                        placeholderText="Select Date"
                                        value={
                                          this.state.startDate && !isToday(this.state.startDate)
                                            ? format(this.state.startDate, 'MM/dd/yyyy')
                                            : ''
                                        }
                                        customInput={<CustomDateInput />}
                                    />
                                    </div>
                                </Form.Group>
                             
                <div>{formattedStart} - {formattedEnd}</div>
                        </div>

                          
                         

                     </div>
                     <div className="card-body">
                       <div className="d-flex justify-content-between align-items-center">
             
                 <div className="text-center">
                   <span className="text-muted small">
                             TOTALS
                           </span>
                           <span className="d-block font-semibold" style={{ fontSize: "30px" }}>
                             {this.state.totalhrs}
                           </span>
                           <span className="text-muted small">
                             hours
                           </span>
                         </div>
             
                   <div className="text-center">
                           <span className="text-muted small">
                             Regular
                           </span>
                           <span className="d-block font-semibold" style={{ fontSize: "30px" }}>
                             {this.state.totalreg}
                           </span>
                           <span className="text-muted small">
                             hours
                           </span>
                         </div>

                         <div className="text-center">
                          <span className="text-muted small">
                             OT
                           </span>
                           <span className="d-block font-semibold" style={{ fontSize: "30px" }}>
                             {this.state.totalot}
                           </span>
                           <span className="text-muted small">
                             hours
                           </span>
                         </div>

                          <div className="text-center">
                          <span className="text-muted small">
                             DOT
                           </span>
                           <span className="d-block font-semibold" style={{ fontSize: "30px" }}>
                             {this.state.totaldot}
                           </span>
                           <span className="text-muted small">
                             hours
                           </span>
                         </div>

                      
                      
                       </div>
                     </div>
                   </div>
              </div>
              </section>

              <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list payroll-tbl1">
                  <BootstrapTable
                    {...props.baseProps}
                    rowEvents={this.rowEvents}
                    keyField="empid"
                    pagination={paginationFactory(options)}
                    rowClasses="table-hover-row"
                    selectRow={{
                      mode: 'checkbox', 
                      clickToSelect: false, 
                      hideSelectAll: true,                     
                      selected:  this.state.searcResult.filter(row => this.state.selectedEmpIds.includes(row.empid)).map(r => r.empid),                     
                      onSelect: (row, isSelect) => {
                        const empid = row.empid; 
                        
                        if (!row.payroll_id) {
                        toast.error('No value added for the employee, cannot select user for pay export.');
                         return false;
                        }

                        let selected = [...this.state.selectedEmpIds];
                        if (isSelect) {
                          selected.push(empid);
                        } else {
                          selected = selected.filter(id => id !== empid);
                        }    

                        const selectedRows = this.state.searcResult.filter(r => selected.includes(r.empid));

                        const totalhrs = selectedRows.reduce((sum, r) => sum + (parseFloat(r.totalHrs) || 0), 0).toFixed(2);
                        const totalot = selectedRows.reduce((sum, r) => sum + (parseFloat(r.ot) || 0), 0).toFixed(2);
                        const totaldot = selectedRows.reduce((sum, r) => sum + (parseFloat(r.dot) || 0), 0).toFixed(2);
                        const reg1 = selectedRows.reduce((sum, r) => sum + (parseFloat(r.regular1) || 0), 0);
                        const reg2 = selectedRows.reduce((sum, r) => sum + (parseFloat(r.regular2) || 0), 0);
                        const totalreg = (reg1+reg2).toFixed(2);
                        this.setState({ selectedEmpIds: selected,totalhrs,totalot ,totaldot,totalreg});
                      },                      
                      // onSelectAll: this.handleOnSelectAllApproval,
                      hideSelectColumn: false,
                      // nonSelectable: this.state.exportedDate
                      // ? this.state.searcResult.map(row => row.empid) 
                      // : this.state.searcResult
                      //     .filter(row => !row.payroll_id)
                      //     .map(row => row.empid)  
                       nonSelectable: this.state.exportedDate
                      ? this.state.searcResult.map(row => row.empid) 
                      : []                 
                    }}
                  />
                  </div>
                </div>
            

              </section>
            </div>

          )
        }
</ToolkitProvider>

 

<div className="d-flex align-items-center justify-content-end height-20">
          {this.state.isSaveOpen && (
            <div className="fixed-action">
              <div className="d-flex align-content-center flex-wrap">
                <div className="mr-auto message">
                  <span>You have unsaved changes</span>
                </div>
                <button
                  type="button"
                  onClick={this.discard}
                  className="btn btn-primary btn-discard"
                >
                  Discard
                </button>
                <button
                  type="button"
                  disabled={this.state.isWait}
                //    onClick={this.saveApi}
                  className="btn btn-primary"
                >
                  {this.state.isWait ? "Loading..." : "Save Changes"}
                </button>
              </div>
            </div>
          )}
                 </div>

          </section>

{(this.state.showLaborSlideout &&
<LaborSlideout
closeSlideOut={this.closeSlideOut}
laborData={this.state.laborData}
periodStartDate = {this.state.periodStartDate}
periodEndDate={this.state.periodEndDate}
biWeekly={this.state.biWeekly}
lock={this.state.exportedDate ? true : false}
>
</LaborSlideout>)}



 {(this.state.isSpinner) && (
                    <div className="loader-spinner d-flex justify-content-center align-items-center flex-column">
                      <Spinner animation="border" variant="success" />
                    </div>
                  )}

          </Container>



        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(LaborTimesheets);